import { PageModel } from "../PageModel";
import { BlockModel } from "../BlockModel";
import { getMaxLoopSize } from "./blockUtilities";

export const pageEquals = (a: PageModel, b: PageModel) =>
    a.blockIndex === b.blockIndex &&
    a.loopIndex === b.loopIndex &&
    a.questions.length === b.questions.length &&
    a.questions[0].index === b.questions[0].index &&
    a.isPrevious === b.isPrevious;

export function getPageIdentifier(page: PageModel, block: BlockModel) {
    const firstQuestion = page.questions[0].index;
    const lastQuestion = page.questions[page.questions.length - 1].index;
    const questionRange =
        firstQuestion === lastQuestion ? firstQuestion : `${firstQuestion}-${lastQuestion}`;
    return `${block.name}[q:${questionRange}/${block.questions.length}, m:${
        page.loopIndex
    }/${getMaxLoopSize(block)}]`;
}
